export const DEFAULT_LAUNCH_DARKLY_FLAGS = {
  erin_test_flag_react: false,
  MultiCalScheduling: false,
  NudgesAutoOpen: false,
  Q12023OnboardingFlexMeetingCalculation: false,
  ShowChatDebugInfo: false,
  CustomJoinAPlanRequest: false,
  "2023Q3LicenseManagement": false,
  ClockwiseAI: false,
  ClockwiseAIMini: false,
  EnableZendeskWebWidget: false,
  M365TeamAvailabilityCalendar: false,
  EnableWelcomePageCanonicalTag: false,
  LinkSettings: false,
  MultiCalendar: true,
  GatewayMonetization: false,
  GatewayPersonalizedStats: false,
  BrowserNotifications: false,
  AIEventSearch: false,
  LinksCustomHours: false,
  LinksMaxBookingsPerDayOrWeek: false,
  OnDemandConflictResolution: false,
  LinksSharedSettings: false,
  LinksPackagingV2: false,
  PlannerMini: false,
  SlackDogfoodApp: false,
  RoundRobinScheduling: false,
  LinksFakeSignIn: false,
  ShareableProposals: false,
  OnboardingLinksSlide: false,
  WorkingLocation: false,
  MaxTeamSizeOverride: 50,
  EnableHelpScoutBeacon: false,
  ScheduleWithAiButton: false,
  "rollout-drag-and-drop-on-calendar": false,
  "rollout-resize-on-calendar": false,
  "kill-switch-g-cal-injections": false,
  "kill-switch-event-modal-observers": false,
  "rollout-ai-chat-chat-input-v-2": false,
  SidebarAIBanner: "Control",
  CalendarSplitView: false,
  DisableFullStory: true,
  OnboardingInviteSelectAll: false,
  PreferredVideoConference: false,
  LinksClone: false,
} as const;

export type LaunchDarklyNameType = keyof typeof DEFAULT_LAUNCH_DARKLY_FLAGS;
export type LaunchDarklyMappingType = {
  [key in LaunchDarklyNameType]: boolean | number | string;
};
